/**
 * Coups de pouce — Attendu 614 « Contrôler les résultats à l'aide d'ordres de grandeur ».
 * Une entrée par generator_key (cf. gen_614.js).
 */

// ── Arrondir chaque facteur, puis multiplier : animation (id cp614play1) ──
// Exemple hors pool du générateur : 6,8 × 2,3 → 7 × 2 = 14.
// Montre les deux sens d'arrondi (6,8 monte +1, 2,3 garde son entier).
const SVG_ORDREMULT_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 236" role="img"
     aria-label="Pour estimer 6,8 fois 2,3 : on arrondit chaque facteur à l'entier le plus proche. Dans 6,8 le premier chiffre après la virgule est 8, c'est 5 ou plus, on monte de 1 : 7. Dans 2,3 c'est 3, c'est moins de 5, on garde 2. Puis 7 fois 2 égale 14 : l'ordre de grandeur est environ 14">
  <g id="cp614play1" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- le produit à estimer -->
  <g font-size="20" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif" text-anchor="middle" opacity="0">
    <text x="108" y="66" text-anchor="end">6</text>
    <text x="117" y="66">,</text>
    <text x="134" y="66">8</text>
    <text x="164" y="66" fill="#64748b">×</text>
    <text x="196" y="66" text-anchor="end">2</text>
    <text x="205" y="66">,</text>
    <text x="222" y="66">3</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+0.3s" fill="freeze"/>
  </g>
  <!-- arrondi du premier facteur : on monte -->
  <g opacity="0">
    <circle cx="134" cy="60" r="11" fill="none" stroke="#1D9E75" stroke-width="1.8"/>
    <text x="118" y="86" font-size="12" font-weight="700" fill="#1D9E75" text-anchor="end" font-family="system-ui,sans-serif">8 ≥ 5 : on monte +1</text>
    <path d="M134,73 L120,96" stroke="#1D9E75" stroke-width="1.8" fill="none" marker-end="none"/>
    <text x="120" y="116" font-size="20" font-weight="700" fill="#1D9E75" text-anchor="middle" font-family="system-ui,sans-serif">7</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+1.6s" fill="freeze"/>
  </g>
  <!-- arrondi du second facteur : on descend -->
  <g opacity="0">
    <circle cx="222" cy="60" r="11" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <text x="236" y="86" font-size="12" font-weight="700" fill="#B45309" text-anchor="start" font-family="system-ui,sans-serif">3 &lt; 5 : on garde 2</text>
    <path d="M222,73 L208,96" stroke="#B45309" stroke-width="1.8" fill="none"/>
    <text x="208" y="116" font-size="20" font-weight="700" fill="#B45309" text-anchor="middle" font-family="system-ui,sans-serif">2</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+3s" fill="freeze"/>
  </g>
  <!-- le calcul simple -->
  <text x="164" y="150" font-size="18" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif" opacity="0">7 × 2 = 14&#8239;: c'est environ 14<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+4.4s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="178" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="186" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Regarde le premier chiffre après la virgule.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+5.6s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="200" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="208" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">si ≥ 5, on monte de 1</text>
    <text x="36" y="224" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">si &lt; 5, on garde l'entier.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play1.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play1.click+6.2s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_ORDREMULT_614 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_ORDREMULT_ANIM,
        },
    ],
};

// ── Estimer l'aire : formule + arrondis (id cp614play2) ──
// 12,3 × 6,2 (hors plage du tirage) : rappel de la formule, puis chaque côté
// s'arrondit à l'entier le plus proche → estimation 12 × 6 = 72 cm².
const SVG_AIRE_ESTIM_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 262" role="img"
     aria-label="Un rectangle de longueur 12,3 centimètres et de largeur 6,2 centimètres. Les arrondis : 12,3 centimètres devient 12 centimètres, et 6,2 centimètres devient 6 centimètres. En face : aire environ égale à 12 fois 6, soit 72 centimètres carrés. Aire du rectangle égale longueur fois largeur ; arrondis chaque côté à l'entier le plus proche">
  <g id="cp614play2" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- le rectangle et ses dimensions -->
  <g opacity="0">
    <rect x="60" y="58" width="148" height="74" fill="#FEF3C7" stroke="#0f172a" stroke-width="1.8"/>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.4s" begin="cp614play2.click+0.3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="134" y="50" font-size="13" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">12,3 cm</text>
    <text x="216" y="99" font-size="13" font-weight="700" fill="#0f172a" text-anchor="start" font-family="system-ui,sans-serif">6,2 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+1.2s" fill="freeze"/>
  </g>
  <!-- les arrondis (numéros alignés à droite, résultat en face) -->
  <text x="30" y="160" font-size="12" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif" opacity="0">Les arrondis :<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+2.4s" fill="freeze"/></text>
  <g opacity="0">
    <text x="104" y="184" font-size="14" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">12,3 cm</text>
    <text x="112" y="184" font-size="14" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif">→ 12 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+3s" fill="freeze"/>
  </g>
  <g opacity="0">
    <text x="104" y="206" font-size="14" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">6,2 cm</text>
    <text x="112" y="206" font-size="14" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif">→ 6 cm</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+3.9s" fill="freeze"/>
  </g>
  <!-- l'estimation, en face des deux lignes -->
  <text x="196" y="197" font-size="15" font-weight="700" fill="#1D9E75" text-anchor="start" font-family="system-ui,sans-serif" opacity="0">Aire ≈ 12 × 6 = 72 cm²<animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/><animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+5s" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="222" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="230" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Aire du rectangle = Longueur × largeur.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+6.4s" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="244" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="252" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Arrondis chaque côté à l'entier le plus proche.</text>
    <animate attributeName="opacity" values="0;0" dur="0.05s" begin="cp614play2.click" fill="freeze"/>
    <animate attributeName="opacity" values="0;1" dur="0.3s" begin="cp614play2.click+7s" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_AIRE_614 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_AIRE_ESTIM_ANIM,
        },
    ],
};


// ── Estimer dans la vie quotidienne : arrondir puis multiplier (id cp614play3) ──
// Une trousse à 10,45 € × 4 : objet, prix et gabarit hors pool (le générateur
// tire des prix ≤ 7,90 € et ne propose pas de trousse) — jamais reproductible.
const SVG_QUOTIDIEN_ANIM = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 240" role="img"
     aria-label="Une trousse coûte 10,45 euros. Environ combien coûtent 4 trousses ? Étape 1 : on arrondit 10,45 à l'entier le plus proche ; le chiffre des dixièmes est 4, moins de 5, on garde 10. Étape 2 : on multiplie l'arrondi par le nombre d'objets : 10 fois 4 égale 40. Les 4 trousses coûtent environ 40 euros">
  <g id="cp614play3" style="cursor:pointer">
    <title>Lancer l'animation</title>
    <rect x="266" y="4" width="86" height="24" rx="12" fill="#1E3A8A"/>
    <path d="M278 10 L278 22 L288 16 Z" fill="#ffffff"/>
    <text x="322" y="20" font-size="12" font-weight="600" fill="#ffffff" text-anchor="middle" font-family="system-ui,sans-serif">Lancer</text>
  </g>
  <!-- l'énoncé -->
  <g opacity="0">
    <text x="20" y="50" font-size="14" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif">Une trousse coûte 10,45 €.</text>
    <text x="20" y="68" font-size="14" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif">Environ combien coûtent 4 trousses ?</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.04;0.09;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
  <!-- étape 1 : arrondir -->
  <g opacity="0">
    <text x="20" y="102" font-size="12" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Étape 1 : arrondir à l'entier le plus proche</text>
    <text x="58" y="126" font-size="16" font-weight="700" fill="#0f172a" text-anchor="end" font-family="system-ui,sans-serif">10</text>
    <text x="64" y="126" font-size="16" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">,</text>
    <text x="78" y="126" font-size="16" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">4</text>
    <text x="96" y="126" font-size="16" font-weight="700" fill="#0f172a" text-anchor="middle" font-family="system-ui,sans-serif">5</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.18;0.24;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <circle cx="78" cy="121" r="10" fill="none" stroke="#B45309" stroke-width="1.8"/>
    <text x="116" y="126" font-size="13" font-weight="700" fill="#B45309" font-family="system-ui,sans-serif">4 &#60; 5 : on garde 10</text>
    <text x="230" y="126" font-size="16" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif">&#8594; 10</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.30;0.38;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
  <!-- étape 2 : multiplier -->
  <g opacity="0">
    <text x="20" y="158" font-size="12" font-weight="600" fill="#64748b" font-family="system-ui,sans-serif">Étape 2 : multiplier par le nombre d'objets</text>
    <text x="40" y="182" font-size="16" font-weight="700" fill="#0f172a" font-family="system-ui,sans-serif">10 × 4 = 40</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.48;0.55;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
  <text x="180" y="182" font-size="15" font-weight="700" fill="#1D9E75" font-family="system-ui,sans-serif" opacity="0">&#8594; environ 40 €<animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.62;0.68;1" dur="12s" begin="cp614play3.click" fill="freeze"/></text>
  <!-- conclusions -->
  <g opacity="0">
    <rect x="20" y="202" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="210" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Arrondis le prix (ou la durée) à l'entier le plus proche.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.76;0.82;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
  <g opacity="0">
    <rect x="20" y="220" width="8" height="8" rx="2" fill="#1E3A8A"/>
    <text x="36" y="228" font-size="13" font-weight="600" fill="#0f172a" font-family="system-ui,sans-serif">Multiplie l'arrondi par le nombre d'objets.</text>
    <animate attributeName="opacity" values="0;0;1;1" keyTimes="0;0.88;0.94;1" dur="12s" begin="cp614play3.click" fill="freeze"/>
  </g>
</svg>`.trim();

const CP_QUOTIDIEN_614 = {
    pages: [
        {
            titre: 'La méthode',
            svg: SVG_QUOTIDIEN_ANIM,
        },
    ],
};

const CP_614 = {
    estimer_quotidien_texte: CP_QUOTIDIEN_614,
    ordremult_qcm_unique: CP_ORDREMULT_614,
    // Entrée partagée : arrondir chaque facteur puis multiplier, le geste
    // est le même dans tous les formats de l'attendu.
    ordremult_relier: CP_ORDREMULT_614,
    ordremult_texte_trou_drag: CP_ORDREMULT_614,
    controle_eleve_qcm_multiple: CP_ORDREMULT_614,
    controle_eleve_tableau_vf: CP_ORDREMULT_614,
    // Formule de l'aire + arrondis de chaque côté (choix prof 2026-08-23)
    estimer_aire_texte: CP_AIRE_614,
};

export default CP_614;
